import { Route } from "react-router";

import { AuthForgotPasswordPage } from "@/components/pages/auth/forgotpassword/page";
import { AuthInvitationOneTimePassPage } from "@/components/pages/auth/invitation/[companyID]/oneTimePass/page";
import { AuthInvitationVerifyPage } from "@/components/pages/auth/invitation/[companyID]/verify/page";
import { AuthResetPasswordPage } from "@/components/pages/auth/resetpassword/page";
import { AuthSignInPage } from "@/components/pages/auth/signIn/page";
import { AuthSignUpPage } from "@/components/pages/auth/signUp/page";
import { AuthVerifyPage } from "@/components/pages/auth/verify/page";
import { AuthVerifyMfaOtpPage } from "@/components/pages/auth/verifyMfaOtp/page";
import { AuthVerifyYourEmailPage } from "@/components/pages/auth/verifyYourEmail/page";

import { AuthRouteGuard } from "./auth-route-guard";
import { PATHS } from "../../paths";

export const AuthRoute = (
	<Route element={<AuthRouteGuard />}>
		{/* Auth系 */}
		<Route path={PATHS.AUTH.SIGN_IN} element={<AuthSignInPage />} index />
		<Route path={PATHS.AUTH.SIGN_UP} index element={<AuthSignUpPage />} />
		<Route path={PATHS.AUTH.VERIFY_YOUR_EMAIL} index element={<AuthVerifyYourEmailPage />} />
		<Route path={PATHS.AUTH.VERIFY_MFA_OTP} index element={<AuthVerifyMfaOtpPage />} />
		<Route path={PATHS.AUTH.VERIFY} index element={<AuthVerifyPage />} />
		<Route path={PATHS.AUTH.RESET_PASSWORD} index element={<AuthResetPasswordPage />} />
		<Route path={PATHS.AUTH.FORGOT_PASSWORD} index element={<AuthForgotPasswordPage />} />
		<Route path={PATHS.AUTH.INVITATION.VERIFY} index element={<AuthInvitationVerifyPage />} />
		<Route path={PATHS.AUTH.INVITATION.ONE_TIME_PASS} index element={<AuthInvitationOneTimePassPage />} />
	</Route>
);
